module.exports = __webpack_public_path__ + "static/media/holos.674b8047.mp4";